import {Pipe, PipeTransform} from "@angular/core";
import {ComparatorService} from "../../services/comparator-service";
import {LastRechtPersonEntryVm} from "../../../core/services/standardrecht-viewmodel.service";

@Pipe({
  name: 'orderByLastRechtPersonEntryVm'
})
export class OrderByLastRechtPersonEntryVmPipe implements PipeTransform {

  public constructor(private comperatorService: ComparatorService) {

  }

  transform(array: Array<LastRechtPersonEntryVm>, ascending = true): LastRechtPersonEntryVm[] {
    if (!array) {
      return;
    }
    if (ascending) {
      return Array.from(array).sort((item1: LastRechtPersonEntryVm, item2: LastRechtPersonEntryVm) => {
        return this.comperatorService.personGbMasterComparator(item1.person, item2.person);
      });
    } else {
      return Array.from(array).sort((item1: LastRechtPersonEntryVm, item2: LastRechtPersonEntryVm) => {
        return this.comperatorService.personGbMasterComparator(item2.person, item1.person);
      });
    }
  }

}
